import { __toESM as e } from "../_virtual/_rolldown/runtime.mjs";
import { CookiesEnum as t } from "../cookies/cookies-enum.mjs";
import { StorageKey as n } from "./storage-key.mjs";
import { useStorage as r } from "./use-storage.mjs";
import { require_md5 as i } from "../node_modules/md5/md5.mjs";
import { useEffect as a } from "react";
import o from "js-cookie";
//#region src/storage/use-session-store.ts
var s = /* @__PURE__ */ e(i()), c = (e) => e ? `${n.SessionStorePrefix}${e}:` : n.SessionStorePrefix, l = (e, { namespace: n, userContextKey: r } = {}) => {
	let i = r ?? o.get(t.UserContextKey);
	return `${c(n)}${i ? (0, s.default)(i) : "shared"}:${e}`;
}, u = (e) => e ? `${t.BrowserSessionActiveId}_${e}` : t.BrowserSessionActiveId, d = (e, t) => o.get(t) === e, f = (e) => {
	a(() => {
		e && o.set(t.UserContextKey, e, {
			path: "/",
			secure: !0,
			sameSite: "strict"
		});
	}, [e]);
}, p = (e, n = {}) => {
	let { namespace: i, userContextKey: s, ...f } = n, p = s ?? o.get(t.UserContextKey), m = p ?? "shared", h = c(i), g = u(i), _ = l(e, {
		namespace: i,
		userContextKey: p
	}), v = r(_, f);
	if (a(() => {
		d(m, g) || (v.removeByPrefix(h), o.set(g, m, {
			sameSite: "strict",
			path: "/"
		}));
	}, [
		g,
		v.removeByPrefix,
		m,
		h
	]), !i) return v;
	let y = () => d(m, g) ? v.getItem() : null;
	return {
		...v,
		getItem: y
	};
};
//#endregion
export { l as getSessionStoreKey, f as useExtendSessionId, p as useSessionStore };
